export default __webpack_public_path__ + "static/media/user-active.a418c675.svg";